<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="row d-flex flex-row align-items-end">
      <div class="col-md-8">
        <div class="ml-auto" style="max-width: 500px;">
          <h6>Группы заказов</h6>
          <table class="table table-bordered table-sm mb-0 ">
            <thead>
              <tr>
                <th>Группа</th>
                <th>Заказы</th>
                <th>Шт</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, productTypeName) in ordersByTypes">
                <td>{{ productTypeName }}</td>
                <td>{{ item.TotalCount }}</td>
                <td>{{ item.Amount }}</td>
                <td>{{ item.Summary }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Итого</td>
                <td>{{totalOrdersByTypes.TotalCount}}</td>
                <td>{{totalOrdersByTypes.TotalAmount}}</td>
                <td>{{totalOrdersByTypes.Summary}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-4">
        <div v-if="allowMarking" class="text-right pb-3">
          <button :class="allIsDelivered ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" type="button"
                  @click="allToDelivered">
            Доставлено
          </button>
          <button :class="allIsPaid ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" type="button"
                  @click="allToPaid">Оплачено
          </button>
          <button :class="allIsPassed ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" type="button"
                  @click="allToPassed">Сдано
          </button>
        </div>
        <div class="text-right">
          <button v-if="isUndeliveredOrdersByDateAndTour" class="btn btn-danger ml-2" @click.prevent="print2">Печать
            недоставленных
          </button>
          <button v-if="allowPrinting" class="btn btn-warning ml-2" v-print="'#printMe'">Печать</button>
          <button class="btn btn-secondary ml-2" type="button" @click="$router.go(-1)">Назад</button>
        </div>
        <!--    <undelivered-orders-by-date-and-tour v-if="isUndeliveredOrdersByDateAndTour" id="printMe2"-->
        <!--                                         :items="undeliveredOrdersByDateAndTour"></undelivered-orders-by-date-and-tour>-->

      </div>
    </div>
    <div class="alert-info p-3 mb-3 mt-3">
      <legend>Выбрано заказов: {{checkedOrders.length}}</legend>
      <div class="d-flex flex-row">
        <div>
          <div>
            <label class="">Выберите статус</label>
          </div>
          <div>
            <button type="button"
                    v-for="status in allowedStatuses"
                    class="btn btn-sm btn-outline-success  mr-3"
                    @click.prevent="setStatus(checkedOrders, status.Code)"
            >{{ status.Name }}
            </button>
          </div>
          <!--          <div class="dropdown">-->
          <!--            <button aria-expanded="false"-->
          <!--                    aria-haspopup="true"-->
          <!--                    class="btn btn-outline-info dropdown-toggle btn-sm btn-block"-->
          <!--                    data-toggle="dropdown" id="dropdownMenuButton" type="button">-->
          <!--              Выберите-->
          <!--            </button>-->
          <!--            <div class="dropdown-menu">-->
          <!--              <h6 class="dropdown-header">Изменить статус</h6>-->
          <!--              <a @click.prevent="setStatus(checkedOrders, status.Code)" class="dropdown-item"-->
          <!--                 href="#" v-for="status in allowedStatuses">{{status.Name}}</a>-->
          <!--              &lt;!&ndash;                <h6 class="dropdown-header">Операции</h6>&ndash;&gt;-->
          <!--              &lt;!&ndash;                <a class="dropdown-item" href="#">Оплачен частично</a>&ndash;&gt;-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div class="ml-md-3">
          <div>
            <label class="">Применить статус счета</label>
          </div>
          <div>
            <button type="button" class="btn btn-sm btn-outline-success"
                    @click.prevent="setBilledStatus(checkedOrders, true)"
            >Счет выставлен</button>
            <button type="button" class="btn btn-sm btn-outline-danger ml-3"
                    @click.prevent="setBilledStatus(checkedOrders, false)"
            >Счет не выставлен</button>
          </div>
        </div>
        <!--        <div class="ml-md-3">-->
        <!--          <div>-->
        <!--            <label class="">Применить дату оплаты</label>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <date-picker :editable="false"-->
        <!--                         :format="momentFormat"-->
        <!--                         @input="setPaidDate(checkedOrders, $event)"-->
        <!--                         clearButton="false"-->
        <!--                         input-class="form-control form-control-sm"-->
        <!--                         lang="ru"-->
        <!--                         :first-day-of-week="1"-->
        <!--                         placeholder=""-->
        <!--                         style="width: auto;"-->
        <!--                         v-model="allPaidDate"-->
        <!--                         valueType="format">-->
        <!--            </date-picker>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="ml-md-3">
          <div>
            <label class="">Применить дату получения</label>
          </div>
          <div>
            <date-picker :editable="false"
                         :format="momentFormat"
                         @input="setPassedDate(checkedOrders, $event)"
                         clearButton="false"
                         input-class="form-control form-control-sm"
                         lang="ru"
                         :first-day-of-week="1"
                         placeholder=""
                         style="width: auto;"
                         v-model="allPassedDate"
                         valueType="format">
            </date-picker>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="text-right pb-3" v-if="allowMarking">-->
<!--      <button :class="allIsDelivered ? 'btn-success' : 'btn-outline-success'"-->
<!--              @click="allToDelivered" class="btn ml-2" type="button">-->
<!--        Доставлено-->
<!--      </button>-->
<!--      <button :class="allIsPaid ? 'btn-success' : 'btn-outline-success'" @click="allToPaid"-->
<!--              class="btn ml-2" type="button">Оплачено-->
<!--      </button>-->
<!--      <button :class="allIsPassed ? 'btn-success' : 'btn-outline-success'" @click="allToPassed"-->
<!--              class="btn ml-2" type="button">Сдано-->
<!--      </button>-->
<!--    </div>-->
<!--    <div class="text-right">-->
<!--      <button @click.prevent="print" class="btn btn-warning ml-2" v-if="allowPrinting">Печать-->
<!--      </button>-->
<!--      <button @click="$router.go(-1)" class="btn btn-secondary ml-2" type="button">Назад</button>-->
<!--    </div>-->
    <div class="mt-3" id="printMe">
      <legend>Сверка {{auditDates.DateStart}} - {{auditDates.DateEnd}}</legend>
      <!--      <table class="table table-sm table-borderless">-->
      <!--        <tbody>-->
      <!--        <tr>-->
      <!--          <td>-->
      <!--            Доставка: {{$route.query.time}}-->
      <!--          </td>-->
      <!--          <td>-->
      <!--            <vue-barcode :margin="0" :value="courierBarCode" :width="2" display-value="false" height="20">-->
      <!--              Ошибка штрихкода-->
      <!--            </vue-barcode>-->
      <!--          </td>-->
      <!--          <td>-->
      <!--            Курьер: {{courier.Mname}} {{courier.Lname}} {{courier.Fname}} ({{courier.Login}})-->
      <!--          </td>-->
      <!--          <td>-->
      <!--            {{currentDate}}-->
      <!--          </td>-->
      <!--        </tr>-->
      <!--        </tbody>-->
      <!--      </table>-->

      <table class="table table-bordered table-hover table-sm w-100 table-cell-align-middle">
        <thead>
        <tr class="">
          <th width="10"></th>
          <th class="d-print-none">
            <input type="checkbox" v-model="checkAll">
          </th>
          <th>Объезд</th>
          <th>Пункт</th>
          <th class="text-right" v-for="paymentType in $root.paymentTypes" width="60">
            {{paymentType.Name}}
          </th>
          <th width="10" class="d-print-none"></th>
          <th class="d-print-none"></th>
          <th class="d-print-none"></th>
          <th class="d-print-none">Дата получения</th>
        </tr>
        </thead>
        <tbody>

        <template v-for="(receptionOrders) in orderListGroupByPoint">
          <template v-for="(order, index) in receptionOrders">
            <template v-if="index === 0">
              <tr class="font-weight-bold">
                <td></td>
                <td class="d-print-none" width="1">
                  <input :checked="fullFilledPoint(order.Point.Id)"
                         @change="checkByPointId($event, order.Point.Id)" type="checkbox">
                </td>
                <td>{{order.Tour.Name}}</td>
                <td :colspan="$root.paymentTypes.length + 1" width="70">
                  {{order.Point.Reception}}
                  <span class="badge badge-light font-weight-normal" style="font-size: 100%;">
                    Итого: <span>{{getReceptionSummary(receptionOrders)}}</span>
                  </span>
                  <span class="badge badge-warning font-weight-normal ml-1" style="font-size: 100%;"
                        v-if="pointDebt[order.Point.Id]">
                    Долг: {{pointDebt[order.Point.Id]}}
                  </span>
                </td>
                <td class="d-print-none"></td>
                <td class="d-print-none"></td>
                <td class="d-print-none"></td>
                <td class="d-print-none"></td>
<!--                <td class="d-none d-print-table-cell" width="10">-->
                  <!--                  <vue-barcode :value="pointBarCode(order.Point)" :width="2" height="20" :margin="0" display-value="false">-->
                  <!--                    Ошибка штрихкода-->
                  <!--                  </vue-barcode>-->
<!--                </td>-->
              </tr>
            </template>
            <tr>
              <td>{{index + 1}}</td>
              <td class="d-print-none" width="1">
                <input :value="order.Order.Id" type="checkbox" v-model="checkedOrders">
              </td>
              <td class="text-nowrap overflow-hidden" style="width: 200px; max-width: 200px; text-overflow: ellipsis;">
                {{order.Order.RecastNumber > 0 ? 'Переделка заказа ' : ''}}
                <router-link class="text-decoration-none text-dark"
                             target="_blank"
                             :to="{ name: 'order-info', params: {orderId: order.Order.Id}}">
                  {{order.Order.SferaNumber}}
                </router-link>
                {{order.Order.LocalNumber && (`/
                ${order.Order.LocalNumber}`)}}
              </td>
              <td class="overflow-hidden text-nowrap"
                  style="max-width: 0; text-overflow: ellipsis;">
                {{order.Order.Name}}
              </td>
              <td class="text-right text-nowrap" v-for="paymentType in $root.paymentTypes">
                {{order.Order.PaymentTypeId === paymentType.Id ? (order.Order.Summary ?
                order.Order.Summary : '') : ''}}
              </td>
              <td class="d-print-none" width="30">
                <button @click.prevent="deleteDelivery([order.AuditItem.Id])"
                        class="btn btn-outline-secondary btn-sm" type="button">
                  <font-awesome-icon :icon="['far', 'trash-alt']"/>
                </button>
              </td>
              <td class="d-print-none" width="50">
                <div class="dropdown">
                  <button :class="statusColor(order.Order.OrderStatusId)"
                          aria-expanded="false"
                          aria-haspopup="true" class="btn dropdown-toggle btn-sm btn-block"
                          data-toggle="dropdown" id="dropdownMenuButton" type="button">
                    {{getStatusNameById(order.Order.OrderStatusId)}}
                  </button>
                  <div class="dropdown-menu">
                    <h6 class="dropdown-header">Изменить статус</h6>
                    <a @click.prevent="setStatus([order.Order.Id], status.Code)"
                       class="dropdown-item" href="#" v-for="status in allowedStatuses">{{status.Name}}</a>
                    <h6 class="dropdown-header">Операции</h6>
                    <a @click.prevent="partPaid(order.Order.Id)" class="dropdown-item" href="#">Оплачен
                      частично</a>
                  </div>
                </div>
              </td>
              <td class="d-print-none" style="" width="170">
                <div class="dropdown">
                  <button id="dropdownMenuButton"
                          :class="billedStatusColor(order.Order.IsBilled)"
                          aria-expanded="false" aria-haspopup="true"
                          class="btn dropdown-toggle btn-sm btn-block" data-toggle="dropdown" type="button">
                    {{ order.Order.IsBilled ? 'Счет выставлен' : 'Счет не выставлен' }}
                  </button>
                  <div class="dropdown-menu">
                    <h6 class="dropdown-header">Изменить статус</h6>
                    <a class="dropdown-item" href="#"
                       @click.prevent="setBilledStatus([order.Order.Id], true)">Счет выставлен</a>
                    <a class="dropdown-item" href="#"
                       @click.prevent="setBilledStatus([order.Order.Id], false)">Счет не выставлен</a>
                    <!--                      <a v-for="status in allowedStatuses" class="dropdown-item" href="#"-->
                    <!--                         @click.prevent="setStatus([order.Order.Id], status.Code)">{{ status.Name }}</a>-->
                    <!--                      <h6 class="dropdown-header">Операции</h6>-->
                    <!--                      <a class="dropdown-item" href="#" @click.prevent="partPaid(order.Order.Id)">Оплачен частично</a>-->
                  </div>
                </div>
<!--                <div class="d-flex flex-row">-->
<!--                  <date-picker :editable="false"-->
<!--                               :format="momentFormat"-->
<!--                               @input="setPaidDate([order.Order.Id], $event)"-->
<!--                               clearButton="false"-->
<!--                               input-class="form-control form-control-sm"-->
<!--                               lang="ru"-->
<!--                               :first-day-of-week="1"-->
<!--                               placeholder=""-->
<!--                               style="width: auto;"-->
<!--                               v-model="order.Order.PaidDate"-->
<!--                               valueType="format">-->
<!--                  </date-picker>-->
<!--                  <button @click.prevent="setDeliveryPaidDate([order.Order.Id])"-->
<!--                          class="btn btn-sm btn-outline-info ml-2"-->
<!--                          content="Назначить дату оплаты из доставки"-->
<!--                          type="button"-->
<!--                          v-tippy>-->
<!--                    <font-awesome-icon :icon="['far', 'calendar-plus']"/>-->
<!--                  </button>-->
<!--                </div>-->
              </td>
              <td class="d-print-none" style="" width="170">
                <div class="d-flex flex-row">
                  <date-picker :editable="false"
                               :format="momentFormat"
                               @input="setPassedDate([order.Order.Id], $event)"
                               clearButton="false"
                               input-class="form-control form-control-sm"
                               lang="ru"
                               :first-day-of-week="1"
                               placeholder=""
                               style="width: auto;"
                               v-model="order.Order.PassedDate"
                               valueType="format">
                  </date-picker>
                  <button @click.prevent="setCurrentPassedDate([order.Order.Id])"
                          class="btn btn-sm btn-outline-info ml-2"
                          content="Назначить текущую дату получения"
                          type="button"
                          v-tippy>
                    <font-awesome-icon :icon="['far', 'calendar-check']"/>
                  </button>
                </div>
              </td>
<!--              <td class="d-none d-print-table-cell" width="">-->
                <!--                <vue-barcode :margin="0" :value="order.Order.SferaNumber" display-value="false" height="20" width="2">-->
                <!--                  Ошибка штрихкода-->
                <!--                </vue-barcode>-->
<!--              </td>-->
            </tr>
          </template>
        </template>
        </tbody>
        <tfoot class="font-weight-bold text-right">
        <tr>
          <td class="d-print-none" colspan="4">Итого в доставке</td>
          <td class="d-none d-print-table-cell" colspan="2">Итого в доставке</td>
          <td class="d-none d-print-table-cell"></td>
          <td v-for="PaymentType in $root.paymentTypes">
            {{totalAmount[PaymentType.Id] || 0}}
          </td>
          <td class="d-print-none" colspan="2"></td>
          <td class="d-print-none">{{totalWithPaidDate}}</td>
          <td class="d-print-none">{{totalWithPassedDate}}</td>
        </tr>
        </tfoot>
      </table>


    </div>

    <v-dialog/>
    <modals-container/>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import VueBarcode from 'vue-barcode';
import DatePicker from 'vue2-datepicker';
import PartnerDelivery from '@/admin/modules/Delivery/_components/PartnerDelivery.vue';
import ReceptionHeadTr from '@/admin/modules/Delivery/_components/ReceptionHeadTr.vue';
import OrderTr from '@/admin/modules/Delivery/_components/OrderTr.vue';
import { get, post, put } from '@/admin/services/api/http-utils';
import AirDatepicker from '@/admin/components/AirDatepicker.vue';
import PartPaid from '@/admin/components/modals/PartPaid.vue';

const url = `${process.env.VUE_APP_API_HOST}admin/audit`;
const type = 'partner';

export default {
  components: {
    DatePicker,
    VueBarcode,
  },
  props: {
    from: String,
    to: String,
    customerId: [String, Number],
    allowPrinting: Boolean,
    allowMarking: Boolean,
  },
  data() {
    return {
      orderList: [],
      orderListGroupByPoint: [],
      statuses: [],
      sferaNumber: '',
      courier: {},
      summaries: [],
      allIsDelivered: null,
      allIsPaid: null,
      allIsPassed: null,
      checkAll: false,
      checkedOrders: [],
      allPassedDate: null,
      allPaidDate: null,
      ordersByTypes: {},
      totalOrdersByTypes: {
        Summary: 0,
        TotalCount: 0,
      },
      momentFormat: {
        // Date to String
        stringify: date => (date ? moment(date)
          .format('DD-MM-YYYY') : ''),
        // String to Date
        parse: value => (value ? moment(value, 'DD-MM-YYYY')
          .toDate() : null),
      },
      pointDebt: [],
      auditDates: {},
    };
  },
  // async created() {
  //
  //   // this.fetchCourier();
  //   // this.calcAll();
  // },
  async mounted() {
    // this.fetchCourier();
    await this.fetchDebtByTourId();
    await this.fetchStatuses();
    await this.fetchAuditListById();
  },
  watch: {
    orderList() {
      if (this.orderList) {
        let arr = _.groupBy(this.orderList, 'Point.Id');
        arr = _.sortBy(arr, x => _.head(x).Tour.Name);
        // arr = _.sortBy(arr, x => _.deburr(_.head(x).Point.Reception));
        arr = arr.sort((a, b) => _.head(a).Point.Reception.localeCompare(_.head(b).Point.Reception));// _.sortBy(arr, x => _.deburr(_.head(x).Point.Reception));
        // arr = _.map(arr, x => _.orderBy(x, ['Point.Reception'], ['desc']));
        this.orderListGroupByPoint = arr;

        const olByProductTypeName = _.groupBy(this.orderList, 'Order.ProductTypeName');
        const formatted = {};
        this.totalOrdersByTypes.Summary = 0;
        this.totalOrdersByTypes.TotalCount = 0;
        this.totalOrdersByTypes.TotalAmount = 0;
        _.each(olByProductTypeName, (col, index) => {
          const Summary = _.sumBy(col, 'Order.Summary');
          const Amount = _.sumBy(col, 'Order.Amount');
          formatted[index] = {
            Summary,
            TotalCount: col.length,
            Amount,
          };
          this.totalOrdersByTypes.Summary += Summary;
          this.totalOrdersByTypes.TotalCount += col.length;
          this.totalOrdersByTypes.TotalAmount += Amount;
        });
        this.ordersByTypes = formatted;
      } else {
        this.orderListGroupByPoint = [];
        this.ordersByTypes = [];
      }
    },
    checkAll(newVal) {
      console.log(newVal);
      if (newVal) {
        this.checkedOrders = _.map(this.orderList, o => o.Order.Id);
      } else {
        this.checkedOrders = [];
      }
    },
    // orders() {
    //   this.calcAll();
    // },
  },
  computed: {
    totalAmount() {
      const totalAmount = {};
      _.each(this.$root.paymentTypes, (val) => {
        totalAmount[val.Id] = _.sumBy(this.orderList, (o) => {
          if (o.Order.PaymentTypeId === val.Id) {
            return o.Order.Summary;
          }
        });
      });
      return totalAmount;
    },
    totalWithPassedDate() {
      let totalAmount = 0;
      _.each(this.orderList, (o) => {
        if (o.Order.PassedDate) {
          totalAmount += o.Order.Summary;
        }
      });
      return totalAmount;
    },
    totalWithPaidDate() {
      let totalAmount = 0;
      _.each(this.orderList, (o) => {
        if (o.Order.PaidDate) {
          totalAmount += o.Order.Summary;
        }
      });
      return totalAmount;
    },
    allowedStatuses() {
      return _.filter(this.statuses, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },
    allChecked() {
      return this.orderList.length === this.checkedOrders.length;
    },
    // customerOrders() {
    //   return _.groupBy(this.orders, order => order.order.CustomerId);
    // },
    courierBarCode() {
      return `cd_${this.$route.query.panelUserId}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
    currentDate() {
      return moment()
        .format('DD-MM-YYYY, h:mm:ss');
    },
  },
  methods: {
    getReceptionSummary(reception) {
      return _.sumBy(reception, 'Order.Summary');
    },
    async setPassedDate(orderItemIds, date) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-passed-date`, { orderItemIds, date });
      this.$toasted.show('Выполнено', { type: 'success' });
      // await this.fetchDebtByTourId();
    },
    async fetchAuditListById() {
      // if (!confirm('Подтвердите действие')) return;
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/audit/audit-list/${this.$route.query.auditListId}`);
      this.auditDates = data;
      // console.log('fauditlist', data);
      // this.$toasted.show('Выполнено', { type: 'success' });
      // await this.fetchDebtByTourId();
    },
    async deleteDelivery(AuditItemIss) {
      // if (!confirm('Подтвердите действие')) return;
      console.log(AuditItemIss);
      // return;
      await post(`${process.env.VUE_APP_API_HOST}admin/audit/delete`, { AuditItemIss });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async setCurrentPassedDate(orderItemIds) {
      this.setPassedDate(orderItemIds, (new Date()).getTime() / 1000);
    },

    async setPaidDate(orderItemIds, date) {
      // if (!confirm('Подтвердите действие')) return;
      const { data } = await put(`${process.env.VUE_APP_API_HOST}admin/order/set-paid-date`, {
        orderItemIds,
        date,
      });
      this.$toasted.show('Выполнено', { type: 'success' });
      // await this.fetchDebtByTourId();
    },
    async setDeliveryPaidDate(orderItemIds) {
      const deliveryDate = _.head(this.orderList).Delivery.DeliveryDate;
      this.setPaidDate(orderItemIds, deliveryDate);
    },

    async setStatus(orderItemIds, statusCode) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-status`, {
        orderItemIds,
        statusCode,
      });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async fetchStatuses() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-status`);
      this.statuses = data.data;// _.filter(data.data, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },

    partPaid(orderItemId) {
      const that = this;
      this.$modal.show(PartPaid, {
        orderItemId,
      }, {
        pivotY: 0.2,
        adaptive: true,
        height: 'auto',
      }, {
        'before-close': function () {
          that.fetchDebtByTourId();
        },
      });
    },

    async fetchDebtByTourId() {
      const { data } = await get(`${url}/orders-by-audit-list-id/${this.$route.query.auditListId}`);
      this.orderList = data;
      // await this.fetchPointDebt();
    },
    async setBilledStatus(orderItemIds, billedStatus) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-billed-status`, { orderItemIds, billedStatus });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    billedStatusColor(isBilled) {
      if (isBilled) {
        return 'btn-success';
      }
      return 'btn-danger';
    },
    async fetchPointDebt() {
      const pointIds = _.map(this.orderList, o => o.Point.Id);
      const { data } = await get(`${url}/point-debt/${pointIds.join(',')}`);
      this.pointDebt = data;
    },
    print() {
      this.$htmlToPaper('printMe');
    },
    // async fetchCourier() {
    //   const { data } = await get(`${url}/couriers/${this.$route.query.panelUserId}`);
    //   this.courier = data;
    // },
    checkByPointId(event, PointId) {
      const value = event.target.checked;
      const orders = _.filter(this.orderList, o => o.Point.Id === PointId);
      const orderIds = _.map(orders, o => o.Order.Id);
      // console.log('orderIds', orderIds);
      let merged = [];
      if (value) {
        merged.push(...this.checkedOrders);
        merged.push(...orderIds);
        merged = _.uniq(merged);
        this.checkedOrders = merged;
      } else {
        this.checkedOrders = _.filter(this.checkedOrders, id => !_.includes(orderIds, id));
      }

      // console.log(event.target.checked, PointId);
    },
    fullFilledPoint(PointId) {
      const orders = _.filter(this.orderList, o => o.Point.Id === PointId);
      const orderIds = _.map(orders, o => o.Order.Id);
      return !_.difference(orderIds, this.checkedOrders).length;
    },
    getStatusNameById(statusId) {
      // console.log(this.statuses, statusId)
      const status = _.find(this.statuses, o => o.Id === statusId);
      // console.log(status)
      return status ? status.Name : '';
      // return status.Name;
    },
    statusColor(statusId) {
      const status = _.find(this.statuses, o => o.Id === statusId);
      if (status && status.Code === 'in_dispatch') {
        return 'btn-danger';
      }
      if (status && status.Code === 'delivered') {
        return 'btn-success';
      }
      return 'btn-outline-info';
    },
    pointBarCode(Point) {
      return `pd_${Point.Id}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
  },
};
</script>
<style lang="scss">
.table-cell-align-middle {
  tr {
    td {
      vertical-align: middle;
    }
  }
}
</style>
